import vars from './_vars';

// Helper functions:
import {throttle} from './functions/throttle';

// Plugins (NPM modules and uploaded files):
import Swiper, {Navigation, Pagination, Autoplay, Thumbs} from 'swiper/bundle'; // import Swiper bundle with all modules installed
// available Swiper.js modules = [Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, Zoom, Lazy, Controller, A11y, History, HashNavigation, Autoplay, Thumbs, FreeMode, Grid, Manipulation, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards]
import './vendors/jquery.nice-select.min.js'; // jQuery Nice Select
import {Fancybox} from "@fancyapps/ui"; // Fancybox

$ = jQuery;

$(document).ready(function ($) {
// jQuery(document).ready(function ($) {
    "use strict";

    $('.tooltipstered').tooltipster();

    Fancybox.bind('.editor img', {});
    Fancybox.bind('.wp-block-image img', {});

    /**
     * Tweak for mobiles (full height)
     */
    const fixFullheight = () => {
        const vh = window.innerHeight * 0.01;
        vars.htmlEl.style.setProperty('--vh', `${vh}px`);
    };

    fixFullheight();
    const fixHeight = throttle(fixFullheight);
    window.addEventListener('resize', fixHeight);


    /**
     * Force load of all lazy-loading images
     */
    setTimeout(function () {
        $('.lazyload.loading').removeClass('loading').addClass('loaded');
    }, 3000);


    /**
     * Nice select
     */
    // do not activate NiceSelect on those pages, where it might conflict with Select2
    if (!$('body').hasClass('woocommerce-account')) {
        $('select').niceSelect();
    }


    /**
     * Trigger NiceSelect update after Woocommerce Update variations
     */
    $(".variations_form").on("woocommerce_variation_has_changed", function () {
        $('.variations_form select').niceSelect('update');
    });


    /**
     * Slider Images
     */
    document.querySelectorAll('.swiper-images').forEach(slider => {
        const swiper = new Swiper(slider, {
            loop: true,
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 0,
            autoplay: false,
            // autoplay: {
            // 	delay: 2500,
            // 	disableOnInteraction: false,
            // },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-button-next'),
                prevEl: slider.querySelector('.swiper-button-prev'),
            },
            on: {
                // lazy load images
                slideChange: function () {
                    try {
                        lazyLoadInstance.update();
                    } catch (e) {
                    }
                }
            }
        });
    });

    // JS Lazyload fix for images on the first screen.
    // This code should run after all the code is initiated.
    $(window).trigger('scroll');


    $('.filter_el').change(function (paged = 1) {
        const filter = $('.events_filter_form');

        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            beforeSend: function (xhr) {
                // console.log('before send ajax');
                $('.events_grid').addClass('is-loading');
            },
            success: function (data) {
                $('.events_grid').html(data.html); // insert data
                $('.pagination-event').html(data.pagination);
                $('.events_grid').removeClass('is-loading');
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(xhr.status);
                console.log(thrownError);
            }
        });
        return false;
    });

    function load_filtered_event(paged = 1) {
        const filter = $('.events_filter_form');
        const radioVal = $('input[name="event_type"]:checked').val();

        $.ajax({
            data: {
            	action: 'events_filter',
            	paged: paged,
                event_type: radioVal,
            },
            url: filter.attr('action'),
            type: filter.attr('method'), // POST
            beforeSend: function () {
                $('.events_grid').addClass('is-loading');
            },
            success: function (response) {
                // console.log(form_data)
                $('.events_grid').html(response.html);
                $('.pagination-event').html(response.pagination);
                $('.events_grid').removeClass('is-loading');

            },
        });
    }


    $(document).on('click', '.pagination-event a', function (e) {
        e.preventDefault();
        let paged = $(this).attr('href').match(/\/page\/(\d+)/)[1];
        $('html, body').animate({
            scrollTop: $('#response').offset().top - 200
        }, 500);
        load_filtered_event(paged);
    });


    $('#advocate-filter').on('change', 'input, select', function(e) {
        e.preventDefault();
        setTimeout(load_filtered_user, 300);

    });
    function load_filtered_user() {
        var formData = $('#advocate-filter').serialize();
        $.ajax({
            type: 'POST',
            url: wpApiSettings.ajaxUrl,
            data: {
                action: 'filter_users',
                form_data: formData,
            },
            beforeSend: function () {
                $('.advocate-list').addClass('is-loading');
            },
            success: function (response) {
                if(response.found > 0){
                    $('.advocate-list').html(response.html);
                }else{
                    $('.advocate-list').html(response.html);
                }
                $('.advocate-list').removeClass('is-loading');
            },
        });
    }

    function load_filtered_enews(paged = 1) {

        let formData = $('.enews_filter_form').serialize();

        $.ajax({
            data: {
                action: 'enews_filter',
                paged: paged,
                form_data: formData,
               // event_type: radioVal,
            },
            type: 'POST',
            url: wpApiSettings.ajaxUrl,
            beforeSend: function () {
                $('.e-news').addClass('is-loading');
            },
            success: function (response) {
                $('.e-news').html(response.html);
                $('.pagination').html(response.pagination);
                $('.e-news').removeClass('is-loading');

            },
        });
    }


    $('.enews_filter_form').on('change', 'input, select', function(e) {
        e.preventDefault();
        load_filtered_enews();
    });

    $(document).on('click', '.e-news-wrapper .pagination a', function (e) {
        e.preventDefault();
        let paged = $(this).attr('href').match(/\/page\/(\d+)/)[1];
        $('html, body').animate({
            scrollTop: $('.e-news').offset().top - 200
        }, 500);
        load_filtered_enews(paged);
    });


    function initMap( $el ) {

        var $markers = $el.find('.marker');

        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        centerMap( map );

        return map;
    }

    function initMarker( $marker, map ) {

        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        var marker = new google.maps.Marker({
            position : latLng,
            map: map
        });

        map.markers.push( marker );

        if( $marker.html() ){

            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    function centerMap( map ) {

        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        } else{
            map.fitBounds( bounds );
        }
    }

    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });

});
